import request from '@/utils/request2'

// 保存终端走访设置
export function saveSchemeStoreVisitSettingApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitSetting/save',
    method: 'post',
    data
  })
}

// 保存活动终端限制清单
export function saveBatchSchemeStoreLimitListApi(data) {
  return request({
    url: 'tms-web/schemeStoreLimitList/saveByBatch',
    method: 'post',
    data
  })
}

// 列表(主数据列表)
export function loadSchemeStoreLimitListDataApi(data) {
  return request({
    url: 'tms-web/schemeStoreLimitList/listByPage',
    method: 'post',
    data
  })
}


// 导出清单
export function exportSchemeStoreLimitListDataApi(data) {
  return request({
    url: 'tms-web/schemeStoreLimitList/exportByPage',
    method: 'post',
    data
  })
}